import { useTranslation } from 'react-i18next';
export const getTools = () => {
    // Get translation function
    const { t, i18n } = useTranslation();
    const TOOLS = {
        crawlWebpage: {
            name: t('Crawl webpage'),
            value: 'crawlWebpage',
            description: t(`Required: {URL}`),
            promptContent: '<tool_function>Crawl the URL. </tool_function>',
        },
        advancedCrawlWebpage: {
            name: t('Crawl webpage (Advanced)'),
            value: 'advancedCrawlWebpage',
            description: t(`Required: {URL}`),
            promptContent: '<tool_function>Crawl the URL with Advanced mode.</tool_function>',
        },
        webSearch: {
            name: t('Web search'),
            value: 'webSearch',
            description: t(`Required: {QUERY}`),
            promptContent: '<tool_function>Web Search.</tool_function>',
        },
        googleSearchResults: {
            name: t('Google Search Results'),
            value: 'googleSearchResults',
            description: t(`Required: {QUERY}.Output: Top 10 ranking URLs and snippets`),
            promptContent: '<tool_function>Google Search Results.</tool_function>',
        },
        academicSearchResults: {
            name: t('Academic Search Results'),
            value: 'academicSearchResults',
            description: t(`Required: {QUERY}.Output: Top 10 ranking URLs and snippets`),
            promptContent: '<tool_function>Academic Search Results.</tool_function>',
        },
        crawlLinkedinProfile: {
            name: t('Crawl Linkedin Profile'),
            value: 'crawlLinkedinProfile',
            description: t(`Required: {LINKEDIN_PROFILE_URL}`),
            promptContent: '<tool_function>Crawl Linkedin Profile.</tool_function>',
        },
        findEmail: {
            name: t('Find Person Email'),
            value: 'findEmail',
            description: t(`Required: {Full Name} & {Company Domain}`),
            promptContent: '<tool_function>Find Person Email.</tool_function>',
        },
        findCompanyEmails: {
            name: t('Find Company Email'),
            value: 'findCompanyEmails',
            description: t(`Required: {Company Domain}`),
            promptContent: '<tool_function>Find Company Email.</tool_function>',
        }
    };
    return TOOLS;
};
